/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Address } from './Address'
import { CodeStub } from './CodeStub'
import { Delegation } from './Delegation'
import { Identifier } from './Identifier'
import { PersonName } from './PersonName'
import { PropertyStub } from './PropertyStub'
import { SecurityMetadata } from './SecurityMetadata'

/**
 * A person related to one or more patients, that is neither a patient nor a healthcare party: typically a contact person (parent of a child
 * patient, caregiver, ...), referenced from a patient's partnership with `partnerType = 'relatedPerson'`. It is a standalone encryptable entity
 * but NOT a crypto actor nor a data owner.
 */
export class RelatedPerson {
  constructor(json: JSON | any) {
    Object.assign(this as RelatedPerson, json)
  }

  /**
   * The id of the related person. We encourage using either a v4 UUID or a HL7 Id.
   */
  id?: string
  /**
   * The revision of the related person in the database, used for conflict management / optimistic locking.
   */
  rev?: string
  /**
   * The identifiers of the related person.
   */
  identifier?: Array<Identifier>
  /**
   * The timestamp (unix epoch in ms) of creation of this entity, will be filled automatically if missing. Not enforced by the application server.
   */
  created?: number
  /**
   * The date (unix epoch in ms) of the latest modification of this entity, will be filled automatically if missing. Not enforced by the application server.
   */
  modified?: number
  /**
   * The id of the User that has created this entity, will be filled automatically if missing. Not enforced by the application server.
   */
  author?: string
  /**
   * The id of the data owner that is responsible for this entity, will be filled automatically if missing. Not enforced by the application server.
   */
  responsible?: string
  /**
   * A tag is an item from a codification system that qualifies an entity as being member of a certain class, whatever the value it might have taken. If the tag qualifies the content of a field, it means that whatever the content of the field, the tag will always apply. For example, the label of a field is qualified using a tag. LOINC is a codification system typically used for tags.
   */
  tags?: Array<CodeStub>
  /**
   * A code is an item from a codification system that qualifies the content of this entity. SNOMED-CT, ICPC-2 or ICD-10 codifications systems can be used for codes
   */
  codes?: Array<CodeStub>
  /**
   * Soft delete (unix epoch in ms) timestamp of the object.
   */
  endOfLife?: number
  /**
   * Hard delete (unix epoch in ms) timestamp of the object.
   */
  deletionDate?: number
  /**
   * The firstname (name) of the related person.
   */
  firstName?: string
  /**
   * The lastname (surname) of the related person.
   */
  lastName?: string
  /**
   * The list of all names of the related person, also containing the official full name information.
   */
  names?: Array<PersonName>
  /**
   * The name of the company this related person is member of.
   */
  companyName?: string
  /**
   * The list of languages spoken by the related person (alpha-2 code http://www.loc.gov/standards/iso639-2/ascii_8bits.html).
   */
  languages?: Array<string>
  /**
   * The addresses and telecoms of the related person.
   */
  addresses?: Array<Address>
  /**
   * Mr., Ms., Pr., Dr. ...
   */
  civility?: string
  /**
   * The gender of the related person: male, female, indeterminate, changed, changedToMale, changedToFemale, unknown
   */
  gender?: RelatedPerson.GenderEnum
  /**
   * Extra properties of the related person.
   */
  properties?: Array<PropertyStub>
  /**
   * The secretForeignKeys are filled at the to many end of a one to many relationship (for example inside Contact for the Patient -> Contacts relationship). Used when we want to find all contacts for a specific patient. These keys are in clear. You can have several to partition the medical document space.
   */
  secretForeignKeys?: Array<string>
  /**
   * The secretForeignKeys are filled at the to many end of a one to many relationship (for example inside Contact for the Patient -> Contacts relationship). Used when we want to find the patient for a specific contact. These keys are the encrypted id (using the hcParty key for the delegate) that can be found in clear inside the patient. ids encrypted using the hcParty keys.
   */
  cryptedForeignKeys?: { [key: string]: Array<Delegation> }
  /**
   * When a document is created, the responsible generates a cryptographically random master key (never to be used for something else than referencing from other entities). He/she encrypts it using his own AES exchange key and stores it as a delegation. The responsible is thus always in the delegations as well
   */
  delegations?: { [key: string]: Array<Delegation> }
  /**
   * When a document needs to be encrypted, the responsible generates a cryptographically random master key (different from the delegation key, never to appear in clear anywhere in the db. He/she encrypts it using his own AES exchange key and stores it as a delegation
   */
  encryptionKeys?: { [key: string]: Array<Delegation> }
  /**
   * The base64 encoded data of this object, formatted as JSON and encrypted in AES using the random master key from encryptionKeys.
   */
  encryptedSelf?: string
  securityMetadata?: SecurityMetadata
}
export namespace RelatedPerson {
  export type GenderEnum = 'male' | 'female' | 'indeterminate' | 'changed' | 'changedToMale' | 'changedToFemale' | 'unknown'
  export const GenderEnum = {
    Male: 'male' as GenderEnum,
    Female: 'female' as GenderEnum,
    Indeterminate: 'indeterminate' as GenderEnum,
    Changed: 'changed' as GenderEnum,
    ChangedToMale: 'changedToMale' as GenderEnum,
    ChangedToFemale: 'changedToFemale' as GenderEnum,
    Unknown: 'unknown' as GenderEnum,
  }
}
